//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'tools',
  props: {
    columns: {
      required: true,
      type: Array
    },
    checkList: {
      required: true,
      type: Array
    },
    localstorageName: {
      type: String
    },
    tools: {
      type: Object
    }
  },
  data () {
    let getCheckList = function () {
      if (this.localstorageName && localStorage.getItem(this.localstorageName)) {
        return localStorage.getItem(this.localstorageName)
      } else {
        return this.checkList
      }
    }
    return {
      checkListCopy: (this.localstorageName && localStorage.getItem(this.localstorageName)) ? JSON.parse(localStorage.getItem(this.localstorageName)) : this.checkList
    }
  },
  watch: {
    checkListCopy (val) {
      this.$emit('checkChange', this.checkListCopy)
      if (this.localstorageName) {
        localStorage.setItem(this.localstorageName, JSON.stringify(this.checkListCopy))
      }
    }
  },
  computed: {
    showSearch () {
      let sign = false
      if (this.tools && this.tools.search && this.tools.search.searchData) {
        let hidePropArr = this.tools.search.searchData.filter(item => {
          return (item.type === 'text')
        })
        if (hidePropArr.length === 0 || (hidePropArr.length < this.tools.search.searchData.length)) {
          sign = true
        }
      }
      return sign
    }
  },
  created () {
    this.$emit('checkChange', this.checkListCopy)
  }
}



// WEBPACK FOOTER //
// ./src/components/tableUnit/components/tools.vue